module.exports = __webpack_public_path__ + "static/media/epay.97e1ca17.svg";